// extracted by mini-css-extract-plugin
export var brand = "_b5-9";
export var compact = "_b5-6";
export var extraSmall = "_b5-7";
export var icon = "_b5-0";
export var large = "_b5-4";
export var light = "_b5-1";
export var medium = "_b5-5";
export var outline = "_b5-b";
export var primaryDark = "_b5-a";
export var primaryLight = "_b5-8";
export var primaryModern = "_b5-c";
export var success = "_b5-2";
export var successSolid = "_b5-3";